import * as _ from 'lodash';

export type ValidationType =
  | 'mail'
  | 'non-negative-integer'
  | 'required'
  | 'tel'
  | 'tenant'
  | 'userId'
  | 'zipcode';

export const helperTextFactory = (type?: ValidationType) => {
  switch (type) {
    case 'mail':
      return '正規のメールアドレスを入力してください。';
    case 'non-negative-integer':
      return '1以上の数字を入力してください。';
    case 'required':
      return '入力必須項目です。';
    case 'tel':
      return '電話番号をハイフンなしで入力してください。';
    case 'tenant':
      return '3～16文字の英数字（アルファベットは小文字のみ）で入力してください。';
    case 'userId':
      return '英数字および「-_@.」のみで入力してください。';
    case 'zipcode':
      return '郵便番号を入力してください。';
  }
  return undefined;
};

export const validationFuncFactory = (type?: ValidationType) => {
  switch (type) {
    case 'mail':
      return isValidMail;
    case 'non-negative-integer':
      return isValidNonNegativeInteger;
    case 'required':
      return (tgt: string) => !_.isEmpty(tgt);
    case 'tel':
      return isValidTel;
    case 'tenant':
      return isValidTenant;
    case 'userId':
      return isValidUserId;
    case 'zipcode':
      return isValidZipCode;
  }
  return (_: string) => true;
};

const REGEXP_MAIL: RegExp = new RegExp(/^.+@.+$/);
export const isValidMail = (tgt: string) => {
  return tgt.match(REGEXP_MAIL) !== null;
};

const REGEXP_NON_NEGATIVE_INTERGER: RegExp = new RegExp(/^[1-9][\d]*$/);
export const isValidNonNegativeInteger = (tgt: string) => {
  return tgt.match(REGEXP_NON_NEGATIVE_INTERGER) !== null;
};

const REGEXP_TEL: RegExp = new RegExp(/^[\d０-９]{9,11}$/);
export const isValidTel = (tgt: string) => {
  return tgt.match(REGEXP_TEL) !== null;
};

const REGEXP_TENANT: RegExp = new RegExp(/^[a-z0-9ａ-ｚ０-９]{3,16}$/);
export const isValidTenant = (tgt: string) => {
  return tgt.match(REGEXP_TENANT) !== null;
};

const REGEXP_USERID: RegExp = new RegExp(/^[\w@\-.Ａ-Ｚａ-ｚ０-９＿＠ー]+$/);
export const isValidUserId = (tgt: string) => {
  return tgt.match(REGEXP_USERID) !== null;
};

const REGEXP_ZIPCODE: RegExp = new RegExp(/^[\d０-９]{3}[-ー]?[\d０-９]{4}$/);
export const isValidZipCode = (tgt: string) => {
  return tgt.match(REGEXP_ZIPCODE) !== null;
};

const convertionMap = new Map([
  ['＿', '_'],
  ['＠', '@'],
  ['ー', '-'],
  ['―', '-'],
  ['‐', '-'],
  ['‑', '-'],
  ['–', '-'],
  ['—', '-'],
  ['−', '-'],
  ['ｰ', '-'],
  ['－', '-'],
]);
const REGEXP_CONVERT = new RegExp(
  '(' + Array.from(convertionMap.keys()).join('|') + ')',
  'g',
);

export const convertFullwidthChar = (str: string) => {
  const converted = str
    .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 65248);
    })
    .replace(REGEXP_CONVERT, (match) => convertionMap.get(match) ?? match);

  return converted;
};
export const convertionTargetTypes: (ValidationType | undefined)[] = [
  'tel',
  'tenant',
  'userId',
  'zipcode',
];
